import {
  IconBriefcase,
  IconCertificate,
  IconChevronLeft,
  IconScubaMask,
  IconUser,
} from '@tabler/icons-react';
import { FC, ReactNode } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

interface Props {}

type SubMenuItem = {
  title: string;
  icon: ReactNode;
  url: string;
};

const SUB_MENU_ITEMS: SubMenuItem[] = [
  {
    title: 'Basic personal info',
    icon: <IconUser size={24} />,
    url: '/profile/basic-personal-info',
  },
  {
    title: 'Travel documents',
    icon: <IconBriefcase size={24} />,
    url: '/profile/travel-documents',
  },
  {
    title: 'Dive certificate',
    icon: <IconCertificate size={24} />,
    url: '/profile/dive-certificate',
  },
  {
    title: 'Dive equipment',
    icon: <IconScubaMask size={24} />,
    url: '/profile/dive-equipment',
  },
];

const SubPageLayout: FC<Props> = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const renderSubMenuItem = ({ title, icon, url }: SubMenuItem) => {
    const isActive = pathname === url || pathname.startsWith(`${url}/`);

    return (
      <button
        type="button"
        className={`flex items-center gap-2 h-[56px] py-4 px-6 font-semibold w-full text-left ${
          isActive
            ? 'bg-neutral-100 text-neutral-900 border-l-4 border-neutral-800'
            : 'text-neutral-800 hover:bg-gray-150 border-l-4 border-transparent'
        }`}
        onClick={() => navigate(url)}
        aria-current={isActive ? 'page' : undefined}
      >
        {icon}
        <span>{title}</span>
      </button>
    );
  };

  return (
    <div className="flex flex-col m-auto max-w-[1140px] md:flex-row md:mt-12 ">
      <div className="my-6 ml-4 md:hidden">
        <button
          type="button"
          className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-lg text-neutral-800 hover:bg-neutral-100"
          onClick={() => navigate('/profile')}
          aria-label="Back to profile"
        >
          <IconChevronLeft size={24} aria-hidden="true" />
        </button>
      </div>
      <nav
        className="w-[320px] h-[256px] rounded-2xl mr-12 border border-neutral-100 hidden md:flex"
        aria-label="Profile sections"
      >
        <div className="py-4 w-full">
          {SUB_MENU_ITEMS.map(item => (
            <div key={item.url}>{renderSubMenuItem(item)}</div>
          ))}
        </div>
      </nav>
      <Outlet />
    </div>
  );
};

export default SubPageLayout;
